export default "__VITE_ASSET__puSgiPxA__"